// import '@babel/polyfill';
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import routes from "./routes";
import moment from "vue-moment";
import request from "./utils/request";
import "vue-simple-context-menu/dist/vue-simple-context-menu.css";
import VueSimpleContextMenu from "vue-simple-context-menu";
import VueSweetalert2 from "vue-sweetalert2";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "xe-utils";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
import Trend from "vuetrend";

Vue.use(Trend);

Vue.use(VXETable);

Vue.config.productionTip = false;

Vue.use(ElementUI);

Vue.prototype.$axios = request;

Vue.use(VueRouter);

Vue.use(moment);

Vue.component("vue-simple-context-menu", VueSimpleContextMenu);

Vue.use(VueSweetalert2);

const router = new VueRouter({
  mode: "history",
  routes,
});

// 抑制 Vue Router 重定向导航的错误日志
const originalPush = router.push.bind(router);
router.push = function push(location) {
  return originalPush(location).catch(err => {
    if (err.name === 'NavigationDuplicated' || String(err).includes('Redirected')) {
      return;
    }
    throw err;
  });
};

// 全局路由守卫：校验登录态
router.beforeEach((to, from, next) => {
  console.log('[守卫] 触发:', to.path, 'from:', from.path);

  // 登录页不需要鉴权
  if (to.path === '/login') {
    console.log('[守卫] 目标为登录页，放行');
    next();
    return;
  }

  // 刚从登录页跳过来，跳过校验避免 session 尚未建立
  if (from.path === '/login') {
    console.log('[守卫] 刚从登录页跳来，跳过校验');
    next();
    return;
  }

  // 调用后端校验 session 是否有效（加时间戳 + 禁用缓存）
  request.get('/vue/check_session', {
    params: { _t: Date.now() },
    headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' }
  }).then(res => {
    console.log('[守卫] check_session 返回:', res);
    if (res.code === 1) {
      console.log('[守卫] 已登录，放行');
      next(); // 已登录
    } else {
      console.log('[守卫] 未登录，跳转 /login');
      next('/login'); // 未登录
    }
  }).catch(err => {
    // 接口异常时视为未登录，跳转登录页
    console.error('[守卫] check_session 请求失败:', err);
    next('/login');
  });
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
